// extracted by css-extract-rspack-plugin
export default {"menuButton":"menuButton-rtmTAt","menuItem":"menuItem-w_8emt"};